// Shared cart item count for the header badge. Fetched at most once per page
// load for signed-in users and refreshed after cart changes.
import { useEffect, useState } from "react";
import * as service from "./service";

let count = null;
let inflight = null;
const listeners = new Set();

function publish(value) {
  count = value;
  listeners.forEach((listener) => listener(value));
}

export function refreshCartCount() {
  if (typeof localStorage === "undefined" || typeof localStorage.keycloak === "undefined") {
    publish(null);
    return Promise.resolve(null);
  }
  if (!inflight) {
    inflight = service
      .checkCart()
      .then(
        (response) => {
          const list = (response && response.data && response.data.cartProductList) || [];
          publish(list.length);
        },
        () => publish(count)
      )
      .then(() => {
        inflight = null;
        return count;
      });
  }
  return inflight;
}

export function useCartCount(enabled) {
  const [value, setValue] = useState(count);
  useEffect(() => {
    listeners.add(setValue);
    if (enabled && count === null) refreshCartCount();
    return () => listeners.delete(setValue);
  }, [enabled]);
  return enabled ? value : null;
}
